module.exports = __webpack_public_path__ + "templates.dialog-delete-credit-card-3e4540d5.html";